import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { Spin, Tabs, TabsProps, Tag } from 'antd';
import * as React from 'react';
import Loader from '../../../../components/Loader';
import NavButton from '../../../../components/NavButton';
import {
  CodeFreeIcons,
  Dollar01FreeIcons, Group01FreeIcons, HomeIconFreeIcons,
  Invoice01FreeIcons,
  Invoice02FreeIcons,
  Settings01FreeIcons, SourceCodeIcon, Store01FreeIcons, UserGroup02FreeIcons
} from '@hugeicons/core-free-icons';

export const Route = createFileRoute('/_authenticated/settings')({
  component: RouteComponent
});

function RouteComponent() {

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={'m-auto h-screen flex'}>
      <div className={'min-h-screen w-[200px] relative top-0 hidden md:block'}>
        <nav className={'w-[200px] min-h-screen border-r fixed top-0 border-slate-200 flex-shrink-0'}>
          <h2 className={'border-b px-5 py-3 font-medium text-lg'}>Impostazioni</h2>
          <div className={'p-2'}>
            <NavButton label={'Generale'} selected={location.pathname === '/settings'} icon={Settings01FreeIcons}
                       collapsed={false} path={'/settings'} />
            <NavButton label={'Abbonamento'} selected={location.pathname === '/settings/billings'}
                       icon={Invoice02FreeIcons} collapsed={false} path={'/settings/billings'} />
            <NavButton label={'Punti Vendita'} selected={location.pathname === '/settings/sales-points'}
                       icon={Store01FreeIcons} collapsed={false} path={'/settings/sales-points'} />
            <NavButton label={'Staff'} selected={location.pathname === '/settings/staff'} icon={UserGroup02FreeIcons}
                       collapsed={false} path={'/settings/staff'} />
            <NavButton label={'Sviluppatori'} selected={location.pathname === '/settings/developers'}
                       icon={SourceCodeIcon} collapsed={false} path={'/settings/developers'} />
          </div>
        </nav>
      </div>
      <div className={'flex-grow min-h-screen relative'}>
        <Outlet />
      </div>
      {/* <Tabs tabPosition={'left'} activeKey={location.pathname === '/settings' ? 'general' : location.pathname.split('/').pop()} onChange={(selected)=> navigate({to: selected === 'general' ? '/settings' : '/settings/'+selected})} items={tabs} />*/}
    </div>
  );
}
